import Modal from '@/components/ui/modal';
import React from 'react';
import VideoPlayer from './video-player';

interface viodeModalProps {
    src: string;
    subtitles?: string;
    showModal: boolean;
    onClose: () => void;
}

export default function VideoModal({ src, subtitles = '', showModal, onClose }: viodeModalProps) {
    return (
        <Modal
            bg="transparent"
            isOpen={showModal}
            onClose={onClose}
            ModalSize="w-full max-w-[962px]"
            overflow="overflow-hidden"
            closePosition="flex items-center justify-center top-[0] right-[0] bg-[rgba(255,255,255,.80)] h-[40px] w-[40px] rounded-[50%]"
            closeColor="#0E0E0E"
            modalPadding="pr-[50px]"
        >
            <VideoPlayer subtitles={subtitles || undefined} src={src} />
        </Modal>
    );
}
